import { useMediaQuery } from 'hooks';
import { LayoutContainer } from 'layout';
import { Button, ButtonSize, SectionContainer } from 'ui';

import {
    screenMobileL,
    screenTablet,
    sectionContainer,
    layoutContainer,
    positionLeft,
    positionRight,
    textWrapper
} from './join-us-section.module.scss';
import { Circle } from 'ui/circle';

export const JoinUsSection = () => {
    const isMobile = useMediaQuery(`(max-width: ${screenMobileL})`);
    const isTablet = useMediaQuery(`(min-width: ${screenTablet})`);

    return (
        <LayoutContainer className={layoutContainer}>
            <SectionContainer className={sectionContainer}>
                {!isTablet ? (
                    ''
                ) : (
                    <>
                        {' '}
                        <Circle position={positionLeft} />
                        <Circle position={positionRight} />
                    </>
                )}

                <div className={textWrapper}>
                    <h3>Join us and get eluminated!</h3>
                    <p>Create your free account now and discover the joy of organizing your knowledge with Elumity.</p>
                </div>
                <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup'}>
                    <Button text="Create free account" fullWidth={isMobile} size={ButtonSize.Medium} />
                </a>
            </SectionContainer>
        </LayoutContainer>
    );
};
